// dashboard
import Analytics from "pages/Dashboards/Analytics";
import Ecommerce from "pages/Dashboards/Ecommerce";
import Email from "pages/Dashboards/Email";
import HRDashboard from "pages/Dashboards/HR";
import SocialMediaDashboard from "pages/Dashboards/SocialMedia";

// Chat
import Chat from "pages/Chat";

// Email
import Mailbox from "pages/Email";

// Calendar
import DefaultCalendar from "pages/Calendar/Default";
import MonthGrid from "pages/Calendar/MonthGrid";
import MultiMonthStack from "pages/Calendar/MultiMonthStack";

// Ecommerce
import ListView from "pages/Ecommerce/Products/ListView";
import GridView from "pages/Ecommerce/Products/GridView";
import Overview from "pages/Ecommerce/Products/Overview";
import AddNew from "pages/Ecommerce/Products/AddNew";
import ShoppingCart from "pages/Ecommerce/ShoppingCart";
import Checkout from "pages/Ecommerce/Checkout";
import Orders from "pages/Ecommerce/Orders";
import Sellers from "pages/Ecommerce/Sellers";

// Notes
import Notes from "pages/Notes";

// Invoices
import InvoiceListView from "pages/Invoices/ListView";
import InvoiceAddNew from "pages/Invoices/AddNew";
// import InvoiceOverview from "pages/Invoices/Overview";

// Users
import UserListView from "pages/Users/ListView";
import UserGridView from "pages/Users/GridView";

// auth
import Basic from "pages/AuthenticationInner/Login/Basic";
import LoginCover from "pages/AuthenticationInner/Login/LoginCover";
import LoginBoxed from "pages/AuthenticationInner/Login/LoginBoxed";
import LoginModern from "pages/AuthenticationInner/Login/LoginModern";

//Register
import BasicRegister from "pages/AuthenticationInner/Register/Basic";
import RegisterCover from "pages/AuthenticationInner/Register/RegisterCover";
import RegisterBoxed from "pages/AuthenticationInner/Register/RegisterBoxed";
import RegisterModern from "pages/AuthenticationInner/Register/RegisterModern";

// EmailVerify
import BasicEmailVerify from "pages/AuthenticationInner/VerifyEmail/Basic";
import EmailCover from "pages/AuthenticationInner/VerifyEmail/EmailCover";
import EmailModern from "pages/AuthenticationInner/VerifyEmail/EmailModern";

// TwoSteps
import BasicTwoSteps from "pages/AuthenticationInner/TwoSteps/Basic";
import TwoStepsCover from "pages/AuthenticationInner/TwoSteps/TwoStepsCover";
import TwoStepsBoxed from "pages/AuthenticationInner/TwoSteps/TwoStepsBoxed";
import TwoStepsModern from "pages/AuthenticationInner/TwoSteps/TwoStepsModern";

// Logout
import BasicLogout from "pages/AuthenticationInner/Logout/Basic";
import LogoutCover from "pages/AuthenticationInner/Logout/LogoutCover";
import LogoutBoxed from "pages/AuthenticationInner/Logout/LogoutBoxed";
import LogoutModern from "pages/AuthenticationInner/Logout/LogoutModern";

// Reset Password
import BasicResetPassword from "pages/AuthenticationInner/ResetPassword/Basic";
import ResetPasswordCover from "pages/AuthenticationInner/ResetPassword/ResetPasswordCover";
import ResetPasswordBoxed from "pages/AuthenticationInner/ResetPassword/ResetPasswordBoxed";
import ResetPasswordModern from "pages/AuthenticationInner/ResetPassword/ResetPasswordModern";

// Create Password
import BasicCreatePassword from "pages/AuthenticationInner/CreatePassword/Basic";
import CreatePasswordModern from "pages/AuthenticationInner/CreatePassword/CreatePasswordModern";
import CreatePasswordCover from "pages/AuthenticationInner/CreatePassword/CreatePasswordCover";
import CreatePasswordBoxed from "pages/AuthenticationInner/CreatePassword/CreatePasswordBoxed";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import Pages404 from "pages/AuthenticationInner/Pages404";
import UserProfile from "pages/Authentication/UserProfile";
import Account from "pages/Pages/Account";
import ComingSoon from "pages/AuthenticationInner/ComingSoon";
import Offline from "pages/AuthenticationInner/Offline";
import Maintenance from "pages/AuthenticationInner/Maintenance";
import Settings from "pages/Pages/Settings";
import Pricing from "pages/Pages/Pricing";
import Faqs from "pages/Pages/Faqs";
import ContactUs from "pages/Pages/ContactUs";
import Diamonds from "pages/Diamond/Products/DIamonds";
import Customers from "pages/Users/Customers";
import Suppliers from "pages/Users/Suppliers";
import SupplierAccount from "pages/Pages/SupplierAccount";
import AddSupplier from "pages/Users/AddSupplier";
import CustomerAccount from "pages/Pages/CustomerAccount";
import AllInventories from "pages/Diamond/Inventory/AllInventories";
import DiamondDetails from "pages/Diamond/Products/DiamondDetails";
import AddInventory from "pages/Diamond/Products/AddDiamonds";
import DiamondOrders from "pages/Diamond/Orders/DiamondOrders";
import Products from "pages/Jewellery/Products";
import SubCategories from "pages/Jewellery/subCategory/SubCategories";
import Categories from "pages/Jewellery/category/Categories";
// import Styles from "pages/Jewellery/style/Styles";
import Shapes from "pages/Diamond/Shapes/Shapes";
import JewelleryOverview from "pages/Jewellery/Products/JewelleryOverview";
import Metals from "pages/Jewellery/metal/Metals";
import AddJewellery from "pages/Jewellery/Products/AddJewellery/index";
import Prices from "pages/Diamond/Prices/Prices";
import JewelleryOrders from "pages/Jewellery/Orders/JewelleryOrders";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import VerifyOTP from "pages/Authentication/VerifyOTP";
import UpdatePassword from "pages/Authentication/UpdatePassword";
import Discount from "pages/Jewellery/Discount/addDiscount";
import AccessDenied from "pages/AuthenticationInner/AccessDenied";
import CreateBlogForm from "pages/Blog/AddBlogForm/createBlog";
import Blogs from "pages/Blog/blog";
import ProductListView from "pages/Jewellery/Products/Listview";
import PreviewBlog from "pages/Blog/PreviewBlog/previewBlog";
import GenerateOrder from "pages/Jewellery/Orders/GenerateOrder/generateOrder";
import RBACTable from "pages/RBAC/RBACTable/RBACTable";
import OrderOverview from "pages/Jewellery/Orders/OrderOverview/OrderOverview";
import InvoiceOverview from "pages/Jewellery/Orders/Invoice/InvoiceOverview";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  // id: string;
  exact?: boolean;
}
interface UserRoleRouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  id: string;
  exact?: boolean;
}

const allRoutes: Array<UserRoleRouteObject> = [
  // { id: "jewellery", path: "/", component: Login },
  // Diamonds
  { id: "inventoried", path: "/inventories", component: AllInventories },
  { id: "diamonds", path: "/diamonds", component: Diamonds },
  { id: "addinventory", path: "/add-inventory", component: AddInventory },
  { id: "diamond", path: "/diamond/:id", component: DiamondDetails },
  { id: "orders", path: "/diamond-orders", component: DiamondOrders },

  // Shapes
  { id: "shapes", path: "/diamond-shapes", component: Shapes },

  // Prices
  { id: "prices", path: "/diamond-prices", component: Prices },

  // Jewellery
  { id: "jewellery", path: "/jewellery", component: Products },
  { id: "overView", path: "/jewellery/:id", component: JewelleryOverview },
  {
    id: "updateProduct",
    path: "/update-jewellery/:id",
    component: AddJewellery,
  },
  {
    id: "duplicateProduct",
    path: "/duplicate-jewellery/:id",
    component: AddJewellery,
  },
  { id: "products", path: "/jewellery", component: Products },
  { id: "addnew", path: "/add-jewellery", component: AddJewellery },
  { id: "orders", path: "/jewellery-orders", component: JewelleryOrders },
  { id: "listView", path: "/jewellery-list-view", component: ProductListView },
  { id: "generateOrder", path: "/generate-order", component: GenerateOrder },
  {
    id: "orderOverView",
    path: "/order-overview/:id",
    component: OrderOverview,
  },
  {
    id: "invoiceOverview",
    path: "/invoice-overview/:id",
    component: InvoiceOverview,
  },

  // Discount
  { id: "discount", path: "/add-discount", component: Discount },

  // Category
  { id: "categories", path: "/categories", component: Categories },

  // Sub Category
  { id: "subcategories", path: "/sub-categories", component: SubCategories },

  // Jewellery Metal
  { id: "metals", path: "/metals", component: Metals },

  //Blog
  { id: "createblog", path: "/create-blog", component: CreateBlogForm },
  { id: "blogs", path: "/blogs", component: Blogs },
  { id: "updateBlog", path: "/update-blog/:id", component: CreateBlogForm },
  { id: "previewBlog", path: "/preview-blog/:id", component: PreviewBlog },

  //RBAC

  { id: "rbactable", path: "/rbac-table", component: RBACTable },

  // Users
  // { id: "customers", path: "/customers", component: Customers },
  // { id: "suppliers", path: "/suppliers", component: Suppliers },
  // { id: "addsupplier", path: "/add-supplier", component: AddSupplier },
];

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  { path: "/", component: Ecommerce },
  { path: "/dashboard", component: Ecommerce },
  { path: "/dashboards-analytics", component: Analytics },
  { path: "/dashboards-email", component: Email },
  { path: "/dashboards-hr", component: HRDashboard },
  { path: "/dashboards-social", component: SocialMediaDashboard },

  // Ui Element

  // Chat
  { path: "/apps-chat", component: Chat },

  // Mailbox
  { path: "/apps-mailbox", component: Mailbox },

  // Calendar
  { path: "/apps-calendar", component: DefaultCalendar },
  { path: "/apps-calendar-month-grid", component: MonthGrid },
  { path: "/apps-calendar-multi-month-stack", component: MultiMonthStack },

  // Ecommerce
  { path: "/apps-ecommerce-product-list", component: ListView },
  { path: "/apps-ecommerce-product-grid", component: GridView },
  { path: "/apps-ecommerce-product-overview", component: Overview },
  { path: "/apps-ecommerce-product-create", component: AddNew },
  { path: "/apps-ecommerce-cart", component: ShoppingCart },
  { path: "/apps-ecommerce-checkout", component: Checkout },
  { path: "/apps-ecommerce-orders", component: Orders },
  { path: "/apps-ecommerce-order-overview", component: OrderOverview },
  { path: "/apps-ecommerce-sellers", component: Sellers },

  // Diamonds
  { path: "/inventories", component: AllInventories },
  { path: "/diamonds", component: Diamonds },
  { path: "/add-inventory", component: AddInventory },
  { path: "/diamond/:id", component: DiamondDetails },
  { path: "/diamond-orders", component: DiamondOrders },

  // Shapes
  { path: "/diamond-shapes", component: Shapes },
  // Prices
  { path: "/diamond-prices", component: Prices },

  // Jewellery
  { path: "/jewellery", component: Products },
  { path: "/jewellery/:id", component: JewelleryOverview },
  { path: "/add-jewellery", component: AddJewellery },
  { path: "/update-jewellery/:id", component: AddJewellery },
  { path: "/duplicate-jewellery/:id", component: AddJewellery },
  { path: "/jewellery-orders", component: JewelleryOrders },
  { path: "/invoice-overview", component: InvoiceOverview },

  // Notes
  { path: "/apps-notes", component: Notes },

  // Invoices
  { path: "/apps-invoice-list", component: InvoiceListView },
  { path: "/apps-invoice-add-new", component: InvoiceAddNew },
  { path: "/apps-invoice-overview", component: InvoiceOverview },

  // Users
  { path: "/customers", component: Customers },
  { path: "/suppliers", component: Suppliers },
  { path: "/add-supplier", component: AddSupplier },
  { path: "/apps-users-list", component: UserListView },
  { path: "/apps-users-grid", component: UserGridView },

  // pages
  { path: "/supplier-account/:supplierId", component: SupplierAccount },
  { path: "/customer-account/:customerId", component: CustomerAccount },
  { path: "/pages-account", component: Account },
  { path: "/pages-account-settings", component: Settings },
  { path: "/pages-pricing", component: Pricing },
  { path: "/pages-faqs", component: Faqs },
  { path: "/pages-contact-us", component: ContactUs },

  // profile
  { path: "/user-profile", component: UserProfile },

  // Category
  { path: "/categories", component: Categories },

  // Sub Category
  { path: "/sub-categories", component: SubCategories },

  //Styles
  // { path: "/styles", component: Styles },

  //Jewellery Metal
  { path: "/metals", component: Metals },

  //Discount
  { path: "/add-discount", component: Discount },
];

const publicRoutes = [
  // auth
  { path: "/auth-login-basic", component: Basic },
  { path: "/auth-login-cover", component: LoginCover },
  { path: "/auth-login-boxed", component: LoginBoxed },
  { path: "/auth-login-modern", component: LoginModern },

  // Register
  { path: "/auth-register-basic", component: BasicRegister },
  { path: "/auth-register-cover", component: RegisterCover },
  { path: "/auth-register-boxed", component: RegisterBoxed },
  { path: "/auth-register-modern", component: RegisterModern },

  // Verify Email
  { path: "/auth-verify-email-basic", component: BasicEmailVerify },
  { path: "/auth-verify-email-cover", component: EmailCover },
  { path: "/auth-verify-email-modern", component: EmailModern },

  // two steps
  { path: "/auth-two-steps-basic", component: BasicTwoSteps },
  { path: "/auth-two-steps-cover", component: TwoStepsCover },
  { path: "/auth-two-steps-boxed", component: TwoStepsBoxed },
  { path: "/auth-two-steps-modern", component: TwoStepsModern },

  // logout
  { path: "/auth-logout-basic", component: BasicLogout },
  { path: "/auth-logout-cover", component: LogoutCover },
  { path: "/auth-logout-boxed", component: LogoutBoxed },
  { path: "/auth-logout-modern", component: LogoutModern },

  //Reset Password
  { path: "/auth-reset-password-basic", component: BasicResetPassword },
  { path: "/auth-reset-password-cover", component: ResetPasswordCover },
  { path: "/auth-reset-password-boxed", component: ResetPasswordBoxed },
  { path: "/auth-reset-password-modern", component: ResetPasswordModern },

  //Create Password
  { path: "/auth-create-password-basic", component: BasicCreatePassword },
  { path: "/auth-create-password-cover", component: CreatePasswordCover },
  { path: "/auth-create-password-boxed", component: CreatePasswordBoxed },
  { path: "/auth-create-password-modern", component: CreatePasswordModern },

  // coming soon
  { path: "/pages-coming-soon", component: ComingSoon },

  // Error
  { path: "/pages-offline", component: Offline },
  { path: "/pages-404", component: Pages404 },

  // Maintenance
  { path: "/pages-maintenance", component: Maintenance },

  //Access Denied
  { path: "/access-denied", component: AccessDenied },

  // authentication
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  // { path: "/register", component: Register },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/otp-verification", component: VerifyOTP },
  { path: "/confirm-password", component: UpdatePassword },
];

export { allRoutes, authProtectedRoutes, publicRoutes };
